import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslate } from "@/i18n";

/**
 * Landing v2 — Final CTA
 * "Börja din resa i Dalarna." — calm action, not urgency.
 */
export default function FinalCtaSection() {
  const t = useTranslate();
  return (
    <section className="py-20 sm:py-28">
      <div className="container max-w-xl mx-auto text-center px-5">
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-foreground tracking-[-0.015em] leading-[1.15]">
          {t("home.finalCta.title")}
        </h2>
        <div className="mt-8">
          <Button
            asChild
            size="lg"
            className="rounded-[24px] px-10 h-12 text-base"
          >
            <Link to="/explore">{t("home.finalCta.cta")}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
